import type { FC } from 'react';

import { WizardProvider } from '../contexts';
import { useSubscriptionLogic } from '~/subscription-box/hooks/useSubscriptionLogic';

export const WizardContainer: FC = ({ children }) => {
  const {
    open,
    customerType,
    wizardType,
    productCode,
    handleClose,
    handleCloseFeedback,
    handleOpenFeedback,
    isFeedbackOpen,
    key,
    handleSave,
    handleError,
  } = useSubscriptionLogic();

  return (
    <WizardProvider
      value={{
        open,
        wizardType,
        customerType,
        onClose: handleClose,
        onError: handleError,
        onSave: handleSave,
        handleCloseFeedback,
        handleOpenFeedback,
        isFeedbackOpen,
        productCode,
        id: key,
      }}
    >
      {children}
    </WizardProvider>
  );
};
